<template>
        <v-container fluid class="py-0">
          <v-row >
            <v-col cols=5>
              <v-select
                :items="marcas_equivalencias"
                v-model="frm.marcaEquiv"
                label="Marca"
                placeholder="Seleccione una marca"
                ref="marcaEquiv"
                append-icon="fa fa-angle-down "
                class="caption"
                menu-props="auto"
                append-outer-icon="fa-refresh"
                @click:append-outer="loadMarcas()"
                clearable
                dense
                hide-details
                return-object
              />
            </v-col>
            <v-col cols=5>
              <v-text-field
                v-model="frm.codigo" 
                label="Código" 
                placeholder="Ingrese un código..." 
                class="caption" 
                dense 
                hide-details  
              />
            </v-col>
            <v-col cols=1 class="text-center"  >
              <v-btn 
                ref="add" 
                x-small 
                class="my-auto mx-0"	
                fab 
                color="primary"	
                @click="addItems()"
                :disabled="!(frm.codigo && frm.codigo.length )"
              >
                <v-icon dense>fa fa-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="px-0">
            <v-col cols=12 >
              <v-data-table
                dense
                :headers="headers"
                :items="Items"
                class="elevation-2"
                :hide-default-header="true"
                min-height="200px"
                height="300px"
                :fixed-header="true"

                hide-default-footer

                :loading="loadGrid"
              
                :mobile-breakpoint=100

                :items-per-page="999"
              >
                <template v-slot:header="{props}">
                  <thead class="v-data-table-header">
                  <tr >
                      <th
                        role="columnheader" scope="col" :aria-label="header.text" 
                        v-for="header in props.headers"
                        :key="header.text"
                        class="text-truncate body-2 primary white--text "
                        :class="header.class "
                        :align="header.align"
                        :width="header.width"
                        v-text="header.text"
                      />
                  </tr>
                  </thead>
                </template>

                <template v-slot:item="{item,isSelected,select,headers} ">
                  <tr>
                    <template v-for="(h, idx) in headers" >
                      <td v-if="h.value!='actions'" :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                      <td v-else :align="h.align" :key="idx" :class="[ h.class]" class="px-1">
                        <v-icon
                          small
                          class="mx-3"
                          @click="editItem(item)"
                        >
                          fa fa-pencil
                        </v-icon>
                        <v-icon
                          small
                          class="mx-3"
                          @click="removeItem(item)"
                        >
                          fa fa-trash-o
                        </v-icon>
                      </td>
                    </template> 
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'CodigosEquiv',
    props:['items'],
    event:'send',

    components: {
      
    },

    data: () => ({
      loadGrid:false,

      headers: [
          { text: 'Marca' ,align: 'start', sortable:true,value:'marca_text'},
          { text: 'Código',align: 'start',sortable: false, value: 'codigo' },
          { text: ''       ,align: 'center'  ,sortable: false, value: 'actions', width:"85px" },
        ],
      default:{
        id:0,
        marca_value:0,
        marca_text:"",
        codigo:""
      },

      editedIndex: -1,
      editedItem :{
        id:0,
        codigo:"",
        marcaEquiv:{}
      },

      frm:{
        id:0,
        codigo:"",
        marcaEquiv:{}
      },

      marcas_equivalencias:[]

    }),
    created: function () {
      console.log("Componente creado")
      console.log("ITEMS --> ", this.items)
      this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
    },
    watch: {
    },

    methods: {
      async loadMarcas () {
        let response
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        //INI MARCAS EQUIV
        response = await fetch(`${this.ROOT_API}marcas_equivalencias`, opt);
        if (response.ok){
          let r=await response.json()
          this.marcas_equivalencias=r.map(item => {
            return {
              value:item.id,
              text:item.descripcion 
            }
          })
        }
        //FIN MARCAS EQUIV
      },

      async initialize () {

        this.loadMarcas()

        let response
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        

        //INI FORMULARIO
        

        
        //FIN FORMULARIO





      },

      editItem (item){
        this.editedIndex = this.items.indexOf(item)
        this.editedItem=Object.assign({}, item)
        
        this.frm={
          marcaEquiv:{value:item.marca_value, text:item.marca_text},
          codigo:item.codigo,
          id:item.id
        }
        

      },

      addItems (){
        if (this.editedIndex==-1){
          console.log("nuevo item")
          this.items.push({
            id: 0,
            marca_value:this.frm.marcaEquiv? this.frm.marcaEquiv.value : null, 
            marca_text :this.frm.marcaEquiv? this.frm.marcaEquiv.text : null, 
            codigo: this.frm.codigo, 
            accion:"I"
          })

        }
        else {
          console.log("edit item")
          this.editedItem.marca_value=this.frm.marcaEquiv.value
          this.editedItem.marca_text=this.frm.marcaEquiv.text
          this.editedItem.codigo=this.frm.codigo
          this.editedItem.accion=this.frm.id?"U":"I"
          
          console.log("e --> ", this.editedItem.accion)

          Object.assign(this.items[this.editedIndex],this.editedItem)


        }

        
        this.frm=Object.assign({},this.default)
        this.editedItem={}
        this.editedIndex=-1
      },

      removeItem (item) {
        if (confirm('Seguro que desea eliminar el item seleccionado?')){
          let index = this.items.indexOf(item)
          console.log("index --> ",index)

          if (item.id!=0){
            console.log("DELETE LOGICO")
            item.accion="D"
            //this.editedIndex = this.items.indexOf(item)
            this.items[index]=Object.assign({}, item)
          }
          else {
            console.log("DELETE")
            this.items.splice(index,1)
          }
        }
      },

      send () {
        //this.frm=Object.assign({},this.default)
        /*
        console.log("PASAJE DE PARAMETROS AL PADRE ",this.items)
        this.items.push({
          codigo: "NUEVO",
          marca_text: "NUEVA MACAR",
          marca_value: 2

        })
        this.$emit('send',this.items)
        */
      },



    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),
      
      Items () {
        let r
        r=this.items.filter( item => item.accion!="D")
        return r
      },
    },
  }
</script>

<style scoped>

</style>
